import {
  TREQUEST_DELETE_TEAM,
  TREQUEST_PLANI8_EMPLOYEE_LIST,
  TREQUEST_UPDATE_PLANI8_EMPLOYEE_LIST,
  TREQUEST_UPDATE_TEAM,
  TRESPONSE_PLANI8_EMPLOYEE_LIST,
  TRESPONSE_TEAM_LIST,
} from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';
import { Action } from '@ngrx/store';
import { TEmployeeListInfoActionType } from './employee-list.models';

export class GetEmployeeList implements Action {
  readonly type = TEmployeeListInfoActionType.GetEmployeeList;
  constructor(public payload: TREQUEST_PLANI8_EMPLOYEE_LIST) {}
}

export class GetEmployeeListSuccess implements Action {
  readonly type = TEmployeeListInfoActionType.GetEmployeeListSuccess;
  constructor(public employeeListRes: TRESPONSE_PLANI8_EMPLOYEE_LIST) {}
}

export class GetEmployeeListFailure implements Action {
  readonly type = TEmployeeListInfoActionType.GetEmployeeListFailure;
  constructor() {}
}

export class UpdateEmployees implements Action {
  readonly type = TEmployeeListInfoActionType.UpdateEmployee;
  constructor(
    public updatePayload: TREQUEST_UPDATE_PLANI8_EMPLOYEE_LIST,
    public fetchPayload: TREQUEST_PLANI8_EMPLOYEE_LIST,
  ) {}
}

export class UpdateEmployeesSuccess implements Action {
  readonly type = TEmployeeListInfoActionType.UpdateEmployeeSuccess;

  constructor() {}
}

export class UpdateEmployeesFailure implements Action {
  readonly type = TEmployeeListInfoActionType.UpdateEmployeeFailure;

  constructor() {}
}

export class GetTeamList implements Action {
  readonly type = TEmployeeListInfoActionType.GetTeamList;
}

export class GetTeamListSuccess implements Action {
  readonly type = TEmployeeListInfoActionType.GetTeamListSuccess;
  constructor(public teamListRes: TRESPONSE_TEAM_LIST) {}
}

export class GetTeamListFailure implements Action {
  readonly type = TEmployeeListInfoActionType.GetTeamListFailure;
  constructor() {}
}

export class DeleteTeams implements Action {
  readonly type = TEmployeeListInfoActionType.DeleteTeams;
  constructor(public deletePayload: TREQUEST_DELETE_TEAM, public fetchEmployeePayload: TREQUEST_PLANI8_EMPLOYEE_LIST) {}
}

export class DeleteTeamsSuccess implements Action {
  readonly type = TEmployeeListInfoActionType.DeleteTeamsSuccess;
  constructor() {}
}

export class DeleteTeamsFailure implements Action {
  readonly type = TEmployeeListInfoActionType.DeleteTeamsFailure;
  constructor() {}
}

export class UpdateTeams implements Action {
  readonly type = TEmployeeListInfoActionType.UpdateTeams;
  constructor(public updatePayload: TREQUEST_UPDATE_TEAM, public fetchEmployeePayload: TREQUEST_PLANI8_EMPLOYEE_LIST) {}
}

export class UpdateTeamsSuccess implements Action {
  readonly type = TEmployeeListInfoActionType.UpdateTeamsSuccess;
  constructor() {}
}

export class UpdateTeamsFailure implements Action {
  readonly type = TEmployeeListInfoActionType.UpdateTeamsFailure;
  constructor() {}
}

export class SetUserPaginationOption implements Action {
  readonly type = TEmployeeListInfoActionType.SetUserPaginationOption;
  constructor(public userPaginationOption: TUserPaginationOption) {}
}

export type TEmployeeListActions =
  | GetEmployeeList
  | GetEmployeeListSuccess
  | GetEmployeeListFailure
  | UpdateEmployees
  | UpdateEmployeesSuccess
  | UpdateEmployeesFailure
  | GetTeamList
  | GetTeamListSuccess
  | GetTeamListFailure
  | DeleteTeams
  | DeleteTeamsSuccess
  | DeleteTeamsFailure
  | UpdateTeams
  | UpdateTeamsSuccess
  | UpdateTeamsFailure
  | SetUserPaginationOption;
